import React from 'react';
import {Link} from 'react-router-dom';
import {t} from 'react-switch-lang';
import BackBtn from './img/arrow-left.svg';
import Dropdown from '../../../components/droppdown/dropdown';
import {ReactComponent as OptionsImg} from './img/options.svg';
import './pageHeader.scss';

const PageHeader = ({
  id,
  disabled,
  allowEdit,
  allowVerify,
  onEdit,
  onVerify,
  acceptButton,
  onAccept,
  onReject,
  requestForUpdateBtn,
  onRequestForUpdate,
  acceptRequestForUpdateBtn,
  onAcceptRequestForUpdate,
  onRejectRequestForUpdate,
  closeButton,
  onCloseRisk,
  decideButton,
  onAcceptDecide,
  onRejectDecide,
  onRejectForDelete
}) => {
  return (
    <div className="page-header d-flex  align-items-center">
      <div className="col-6 p-0">
        <Link to="/dashboard" className="return-btn d-flex align-items-center">
          <img src={BackBtn} alt="icon" />
          <span>
            {id === undefined
              ? t('incurred-risk.page-header-add')
              : t('incurred-risk.page-header-show')}
          </span>
        </Link>
      </div>

      <div className="col-6 p-0 d-flex align-items-center justify-content-end">
        {allowEdit &&
          disabled &&
          id !== undefined &&
          !window.location.pathname.includes('edit') && (
            <button className="btn primary-submit" onClick={(e) => onEdit(e)}>
              {t('buttons.changeBtn')}
            </button>
          )}
        {requestForUpdateBtn && id !== undefined && (
          <button
            className="btn primary-submit"
            onClick={() => onRequestForUpdate()}
          >
            {t('buttons.requestToEdit')}
          </button>
        )}
        {closeButton && id !== undefined && (
          <button
            className="btn primary-submit"
            onClick={(e) => onCloseRisk(e)}
          >
            {t('buttons.closeRisk')}
          </button>
        )}

        {allowVerify && id !== undefined && (
          <button className="btn primary-submit" onClick={(e) => onVerify(e)}>
            {t('buttons.verifyBtn')}
          </button>
        )}

        {acceptButton && id !== undefined && (
          <>
            <button className="btn primary-submit" onClick={(e) => onAccept(e)}>
              {t('buttons.accept')}
            </button>
            <button
              className="btn primary-cancel "
              type="reset"
              onClick={(e) => onReject(e)}
            >
              {t('buttons.refuse')}
            </button>
          </>
        )}

        {decideButton && id !== undefined && (
          <>
            <button
              className="btn primary-submit"
              onClick={(e) => onAcceptDecide(e)}
            >
              {t('buttons.acceptRiskSector')}
            </button>
            <button
              className="btn primary-cancel "
              type="reset"
              onClick={(e) => onRejectDecide(e)}
            >
              {t('buttons.rejectRiskSector')}
            </button>
          </>
        )}

        {acceptRequestForUpdateBtn && id !== undefined && (
          <>
            <button
              className="btn primary-submit"
              onClick={(e) => onAcceptRequestForUpdate(e)}
            >
              {t('buttons.acceptUpdate')}
            </button>
            <button
              className="btn primary-cancel "
              type="reset"
              onClick={(e) => onRejectRequestForUpdate(e)}
            >
              {t('buttons.refuseUpdate')}
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default PageHeader;
